import React from 'react'
import { Link, useLocation, matchPath } from 'react-router-dom'

import { HeaderButton as MauiHeaderButton } from '@maui/elements'

export const HeaderButton = ({ exact, ...props }) => {
  const location = useLocation()
  const path = typeof props.to === 'function' ? props.to(location) : props.to
  const active = !!matchPath(location.pathname, {
    path,
    exact,
    strict: false
  })
  return <MauiHeaderButton as={Link} active={active} {...props} />
}
